import ProdutoTributacaoService from "@/services/ProdutoTributacaoService";

export const produtoTributacao = {
  namespaced: true,
  state: {
    produtoTributacao: {},
  },
  actions: {
    getProdutoTributacao({ commit }, payload) {
      return ProdutoTributacaoService.GetProdutoTributacao(payload).then(
        (produtoTributacao) => {
          return Promise.resolve(produtoTributacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProdutoTributacao({ commit }, payload) {
      return ProdutoTributacaoService.PostProdutoTributacao(payload).then(
        (produtoTributacao) => {
          return Promise.resolve(produtoTributacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProdutoTributacao({ commit }, payload) {
      return ProdutoTributacaoService.PutProdutoTributacao(payload).then(
        (produtoTributacao) => {
          return Promise.resolve(produtoTributacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProdutoTributacao({ commit }, payload) {
      return ProdutoTributacaoService.DeleteProdutoTributacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdutoTributacaoOData({ commit }, payload) {
      return ProdutoTributacaoService.GetProdutoTributacaoOData(payload).then(
        (produtoTributacao) => {
          return Promise.resolve(produtoTributacao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default produtoTributacao;
